module.exports = __webpack_public_path__ + "img/mi_delete.d6fb0f44.svg";